export const NUMBER_DIRECTIONS = [
  { id: "higher", label: "Higher" },
  { id: "lower", label: "Lower" },
];

export function formatBondNumbersCoin(value) {
  const n = Math.floor(Number(value) || 0);
  return n.toLocaleString("en-US");
}

export function pickLabel(pick) {
  const p = String(pick || "").toLowerCase();
  if (p === "higher") return "Higher";
  if (p === "lower") return "Lower";
  return "—";
}

export function numberLabel(value) {
  const n = Math.floor(Number(value));
  if (!Number.isFinite(n)) return "—";
  return String(n);
}

export function resolveBondNumbersSettledRound({
  revealedRound = null,
  lastSettled = null,
  ticketRound = null,
} = {}) {
  const ticketId = String(ticketRound?._id || ticketRound?.id || "");
  for (const candidate of [revealedRound, lastSettled]) {
    if (candidate?.outcome == null) continue;
    const candidateId = String(candidate._id || candidate?.id || "");
    if (!ticketId || !candidateId || candidateId === ticketId) return candidate;
  }
  return null;
}

export function formatOddsMultiplier(odds) {
  const n = Number(odds);
  if (!Number.isFinite(n)) return "—";
  return Number.isInteger(n) ? `${n}×` : `${n.toFixed(2)}×`;
}

export function computeBondNumbersQuote(stake, constants) {
  const resolvedStake = Math.floor(Number(stake) || 0);
  if (resolvedStake <= 0) return null;
  const odds = Number(constants?.odds || 2);
  if (!Number.isFinite(odds) || odds <= 1) return null;
  const grossPayout = Math.floor(resolvedStake * odds);
  return {
    stake: resolvedStake,
    odds,
    grossPayout,
    reserve: Math.max(0, grossPayout - resolvedStake),
    maxWin: grossPayout,
  };
}
